module.exports = __webpack_public_path__ + "2751ee43015f9884c3642f103b7f70c9.woff2";